export function destroyAds() {
    try {
        // @ts-ignore
        (window.asc = window.asc || { cmd: [] }).cmd.push(function () {
            // @ts-ignore
            window.asc.destroy();
        });
    } catch (e) {}
}
